import { Box, Button, CircularProgress, Divider, Drawer, TextField } from "@mui/material"
import { useState } from "react";
import validator from 'validator';
import { addAdmin } from "../services/admin";
import { enqueueSnackbar } from "notistack";

const AdminFormDrawer = ({
  open,
  handleClose,
  getData
}) => {

  const [name, set_name] = useState('');
  const [email, set_email] = useState('');
  const [password, set_password] = useState('');
  const [contact_number, set_contact_number] = useState('');
  const [is_saving, set_is_saving] = useState(false);

  const handleSave = async () => {
    set_is_saving(true);

    const { data, error } = await addAdmin({
      name : name,
      email : email,
      password : password,
      contact_number : contact_number
    })

    set_is_saving(false);

    if(data){
      
      if(data.success){
        enqueueSnackbar('Admin user added successfully !', {
          variant : 'success'
        });
        closeDrawer();
        getData();
      }else{
        enqueueSnackbar(data.message, {
          variant : 'error'
        });
      }

    }
    if(error){
      enqueueSnackbar('Error while adding admin', {
        variant : 'error'
      })
    }
  }

  const closeDrawer = () => {
    set_name('');
    set_email('');
    set_password('');
    set_contact_number('');
    handleClose();
  }

  return (
    <Drawer
      open={open}
      onClose={closeDrawer}
      sx={{
        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: '400px', padding: '20px', paddingTop: '80px' }
      }}
      anchor="right"
    >
      <TextField
        label='Name'
        fullWidth
        sx={{
          marginBottom: '20px'
        }}
        value={name}
        onChange={(e) => set_name(e.target.value)}
      />
      
      <TextField
        label='Email'
        fullWidth
        sx={{
          marginBottom: '20px'
        }}
        value={email}
        onChange={(e) => set_email(e.target.value)}
      />

      <TextField
        type="password"
        label='Password'
        fullWidth
        sx={{
          marginBottom: '20px'
        }}
        value={password}
        onChange={(e) => set_password(e.target.value)}
      />

      <TextField
        label='Contact Number'
        fullWidth
        sx={{
          marginBottom: '20px'
        }}
        value={contact_number}
        onChange={(e) => set_contact_number(e.target.value)}
      />

      <Divider />

      <Box
        display='flex'
        justifyContent='flex-end'
        gap='20px'
        marginTop='20px'
      >
        <Button
          variant="outlined"
          onClick={closeDrawer}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={
            is_saving ||
            !Boolean(name) ||
            !validator.isEmail(email) ||
            !Boolean(password) ||
            !Boolean(contact_number)
          }
          onClick={handleSave}
        >
          {is_saving ? <CircularProgress /> : 'Save'}
        </Button>
      </Box>
    </Drawer>
  )
}

export default AdminFormDrawer;